// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__lTz1c","inner":"Footer_inner__3Zt18","nextIcon":"Footer_nextIcon__3C4i7","innerLeft":"Footer_innerLeft__2EsDw"};